<template>
    <div>
        <Mainlayout></Mainlayout>
        <CCol sm="12" style="background-size: cover;height: 100vh;" :style="{ backgroundImage: `url(${backgroundUrl})` }">
            <CCol sm="12" lg="12">
                <CRow>
                    <CCol sm="12" lg="12">
                        <div style="margin-top: 10%">
                            <CCol sm="12" style="width: 50%;background-size: cover; margin: auto;">
                                <CCard class="border-radius-16px p-4 mb-5">
                                    <div class="text-center">
                                        <h3 class="custom-32px-500 text-center font-color-171717">Verification</h3>
                                        <p class="custom-16px-400">A verification code has been sent to </p>
                                    </div>
                                    <div class="mt-3">
                                        <CCol md="8" class="text-center mt-3 d-none d-sm-block" style="width: 90%; background-size: cover; margin: auto;">
                                            <h5 class="custom-18px mt-2 text-left">Verify Code</h5>
                                            <div class="ustom-sub-title-app text-left mb-5">
                                                Please enter the code we just sent to {{ email }}
                                            </div>
                                            <div class="verification-input">
                                                <input v-model="code[0]" maxlength="1" style="width:20%" class="custom-code mr-2" />
                                                <input v-model="code[1]" maxlength="1" style="width:20%" class="custom-code mr-2" />
                                                <input v-model="code[2]" maxlength="1" style="width:20%" class="custom-code mr-2" />
                                                <input v-model="code[3]" maxlength="1" style="width:20%" @change="submitVerification" class="custom-code" />
                                            </div>
                                        </CCol>
                                        <!-- Column for mobile view -->
                                        <CCol xs="12" class="text-center mt-3 d-sm-none" style="width: 100%; background-size: cover; margin: auto;">
                                            <h5 class="custom-18px mt-2 text-left ml-4">Verify Code</h5>
                                            <div class="ustom-sub-title-app text-left mb-5 ml-4">
                                                Please enter the code we just sent to {{ email }}
                                            </div>
                                            <div class="verification-input">
                                                <input v-model="code[0]" maxlength="1" style="width:20%" class="custom-code mr-2" />
                                                <input v-model="code[1]" maxlength="1" style="width:20%" class="custom-code mr-2" />
                                                <input v-model="code[2]" maxlength="1" style="width:20%" class="custom-code mr-2" />
                                                <input v-model="code[3]" maxlength="1" style="width:20%" class="custom-code" />
                                            </div>
                                        </CCol>
                                    </div>
                                    <div style="clear:both"></div>
                                    <div class="text-center mt-5">
                                        <span class="custom-border-purple p-2 text-center text-white" v-on:click="submitVerification">
                                                            <label class="ml-2 mr-2">Continue</label></span>
                                        <br />
                                    </div>
                                </CCard>
                            </CCol>
                        </div>
    
    
    
                    </CCol>
    
                </CRow>
            </CCol>
        </CCol>
    
    
    
    </div>
</template>


<script>
import Vue from "vue";

import GAuth from 'vue-google-oauth2'

const gauthOption = {
    clientId: '1076578801027-kt1ptr3hd1ou78tlj65vmfaj8tgafq72.apps.googleusercontent.com',
    scope: 'profile email',
    prompt: 'consent',
    fetch_basic_profile: true,
    plugin_name: 'vue-google-oauth2',
}

Vue.use(GAuth, gauthOption)

import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgPurpleYellow.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bgline.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';


export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundUrNoArrow,

            backgroundGenie,
            email: this.$route.query.email,
            code: ["", "", "", ""],





        };
    },


    methods: {
        submitVerification() {
            this.verificationCode = this.code.join(""); // Concatenate the digits
            console.log("Verification Code:", this.verificationCode);
            this.ValidateCode(this.verificationCode);
        },
        ValidateCode(verificationCode) {

            const formData = new FormData();

            formData.append("userEmail", this.$route.query.email);
            formData.append("code", verificationCode);

            return this.$API
                .post(this.$ValidateForgotPasswordCode, formData, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data > 0) {
                       
                       this.$router.push("ResetPassword?email="+ this.$route.query.email + "&code=" + verificationCode);
                    } else {
                        this.ErrorMessage = true;
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        console.log(error.response.data);
                        this.Error = true;
                        this.Message = error;
                        this.Message = "Error";

                        this.ErrorMessage = true;
                    }
                });
        },



    },

};
</script>

<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}
</style>